/**
 * Splits one date's selected hours into one bucket per court, courts in
 * number order and each court's hours in the order they came in (the caller
 * passes them already sorted by time).
 * @param {Array<{dateStr: string, timeSlot: string, court: number, price: number}>} rows
 * @returns {Array<{court: number, rows: Array<object>, total: number}>}
 */
export const groupSelectedRowsByCourt = (rows = []) => {
  const byCourt = new Map();
  rows.forEach((row) => {
    const court = Number(row.court);
    if (!byCourt.has(court)) byCourt.set(court, { court, rows: [], total: 0 });
    const bucket = byCourt.get(court);
    bucket.rows.push(row);
    bucket.total += Number(row.price) || 0;
  });
  return [...byCourt.values()].sort((a, b) => a.court - b.court);
};

/**
 * "(1 hr)" / "(3 hrs)" — the hour count a court card's header shows.
 * @param {number} count
 * @returns {string}
 */
export const formatHourCount = (count) => {
  const n = Number(count) || 0;
  return `(${n} ${n === 1 ? 'hr' : 'hrs'})`;
};
